import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 256 180"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#i1789720600__a)\"><path fill=\"#000\" d=\"M250.346 28.075A32.17 32.17 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.17 32.17 0 0 0 22.657-22.657c6.338-35.348 8.291-89.101-.164-123.135\"></path><path fill=\"#fff\" d=\"m102.421 128.06 66.328-38.418-66.328-38.418z\"></path></g><defs><clipPath id=\"i1789720600__a\"><path fill=\"#fff\" d=\"M0 0h256v180H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }